<template lang='pug'>
 v-layout(align-start)
    v-flex
        v-card(style='padding: 1em')
          v-row(dense, justify='space-between')
            v-col(cols='12', xs='12', sm='5')
              v-autocomplete(automcomplete='off', outlined, dense, label='Promotores' :items='promotores' v-model='promotorSelect')
            v-col(cols='12', xs='12', sm='5')
              v-row
                v-btn(:disabled='!promotorSelect' fab='' text='' small='' color='grey darken-2' @click='prev')
                  v-icon(small='') mdi-chevron-left
                v-btn(:disabled='!promotorSelect' fab='' text='' small='' color='grey darken-2' @click='next')
                  v-icon(small='') mdi-chevron-right
                h2(v-if='$refs.calendar') {{ $refs.calendar.title }}
          v-row
            v-col(cols='12')
              v-sheet(height='600')
                v-calendar(
                    ref="calendar",
                    locale='es',
                    v-model="value",
                    :events='promotorSelect.planificacion',
                    :weekdays="weekday",
                    type="month",
                    @click:date='openModal')

            //- dialog para los clientes
            v-dialog(v-model='dialog' persistent scrollable max-width='80%')
              v-card(color='grey_1')
                v-app-bar(dark color='primary')
                  v-toolbar-title.headline Clientes
                v-card-text
                  v-row(dense)
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' sm='12' md='6')
                              v-autocomplete(
                                :readonly='!puedeModificar'
                                dense
                                outlined
                                v-model='clienteSelect'
                                :items='clientesArray'
                                label='Clientes')
                            v-col(cols='12' sm='12' md='6')
                                v-btn(
                                  v-if='puedeModificar'
                                  color='success'
                                  small
                                  dark
                                  style='margin-left: 1rem'
                                  @click='addCliente')
                                    v-icon mdi-plus
                                    | Agregar
                          v-row(dense)
                            v-col(cols='12')
                              v-data-table(:headers='headerClientes', :items='clientes')
                                template(v-slot:item.action='{ item }')
                                  v-tooltip(v-if='item.productos && item.productos.length > 0'  bottom)
                                    template(v-slot:activator='{ on }')
                                      v-icon(color='primary_2' @click='showCliente(item)' v-on="on") mdi-eye
                                    | Ver
                                  v-tooltip(bottom)
                                    template(v-slot:activator='{ on }')
                                      v-icon(v-if='puedeModificar' color='error' @click='deleteCliente(item)' v-on="on") mdi-delete
                                    | Eliminar
                v-card-actions
                  v-spacer
                  v-btn(color='error' small='' dark='' @click='close')
                    v-icon mdi-close
                    | Cancelar
                  v-btn(color='success' small='' dark='' @click='save')
                    v-icon mdi-content-save
                    | Guardar
            //-dialog para los productos
            v-dialog(v-model='dialogCliente' persistent scrollable max-width='80%')
              v-card(color='grey_1')
                v-app-bar(dark color='primary')
                  v-toolbar-title.headline Clientes
                v-card-text
                  v-row(dense)
                    v-col(cols='12')
                      v-card
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' md='5')
                              v-text-field(
                                label='Cliente'
                                readonly
                                outlined
                                dense
                                v-model='cliente.idCliente.nombre')
                  v-row(dense v-for='categoria in cliente.productos')
                    v-col(cols='12')
                      v-data-table.elevation-1(
                        :items='categoria.productos'
                        :headers='headersProductos'
                        hide-default-footer
                        :items-per-page='-1')
                        template(v-slot:top)
                          v-toolbar.header-toolbar-compras(flat color='primary' dark dense)
                            v-flex(class="d-flex flex-wrap justify-center")
                              v-toolbar-title.main-head categoria: {{ cliente._id.descripcion }}
                              v-spacer
                        template(v-slot:item.inventario='{ item }')
                          v-text-field(
                            readonly
                            type='number',
                            v-model.number='item.inventario',
                            min='0',
                            style='width: 125px',
                            dense)
                        template(v-slot:item.fechaVencimiento='{ item }')
                          v-text-field(
                            readonly
                            type='date',
                            v-model='item.fechaVencimiento',
                            dense)
                        template(v-slot:item.mueblePrincipal='{ item }')
                          v-text-field(
                            readonly
                            type='number',
                            v-model.number='item.mueblePrincipal',
                            min='0',
                            style='width: 100px',
                            dense)
                        template(v-slot:item.muebleSecundario='{ item }')
                          v-text-field(
                            readonly
                            type='number',
                            v-model.number='item.muebleSecundario',
                            min='0',
                            style='width: 100px',
                            dense)
                v-card-actions
                  v-spacer
                  v-btn(color='error' small='' dark='' @click='closeCliente')
                    v-icon mdi-close
                    | Cancelar
</template>

<script>
import Api from '@/services/methods'
export default {
  data: () => ({
    dateActual: new Date().toISOString().substr(0, 10),
    dialog: false,
    dialogCliente: false,
    puedeModificar: false,
    promotorSelect: '',
    clienteSelect: '',
    date: '',
    type: 'month',
    value: '',
    indexSelected: -1,
    weekday: [0, 1, 2, 3, 4, 5, 6],
    events: [],
    clientes: [],
    clientesArray: [],
    headerClientes: [
      { text: 'Nombre', value: 'idCliente.nombre', align: 'left', sortable: false },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    headersProductos: [
      { text: 'SubCategoria', value: 'sublinea', align: 'left', sortable: false },
      { text: 'Producto', value: 'idProducto.nombre', align: 'left', sortable: false },
      { text: 'fecha Vencimiento', value: 'fechaVencimiento', align: 'left', sortable: false },
      { text: 'inventario', value: 'inventario', align: 'left', sortable: false },
      { text: 'Mueble Principal', value: 'mueblePrincipal', align: 'left', sortable: false },
      { text: 'Mueble Secundario', value: 'muebleSecundario', align: 'left', sortable: false }
    ],
    promotores: [],
    cliente: {
      _id: '',
      productos: [],
      idCliente: {}
    },
    defaultCliente: {
      _id: '',
      productos: [],
      idCliente: {}
    }
  }),

  created () {
    this.initialize()
  },

  mounted () {
    this.$refs.calendar.checkChange()
  },

  methods: {

    initialize () {
      this.getPromotores()
      this.getClientes()
    },

    getPromotores () {
      Api.get('planificacion')
        .then(response => {
          response.data.forEach(promotor => this.promotores.push({
            value: { _id: promotor._id, nombre: promotor.nombre, apellido: promotor.apellido, planificacion: promotor.planificacion },
            text: `${promotor.nombre} ${promotor.apellido}`
          }))
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    getClientes () {
      Api.get('/cliente')
        .then(response => {
          this.clientesArray = []
          response.data.forEach(cliente => {
            this.clientesArray.push({
              value: { _id: cliente._id, nombre: cliente.nombre },
              text: cliente.nombre
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    prev () {
      this.$refs.calendar.prev()
    },

    next () {
      this.$refs.calendar.next()
    },

    showCliente (cliente) {
      this.cliente = Object.assign({}, cliente)
      this.dialogCliente = true
    },

    closeCliente () {
      this.cliente = Object.assign({}, this.defaultCliente)
      this.dialogCliente = false
    },

    openModal (date) {
      if (!this.promotorSelect) return null
      const dateActual = this.$moment(this.dateActual)
      const dateOpen = this.$moment(date.date)
      console.log(dateActual.diff(dateOpen, 'days'))
      if (dateActual.diff(dateOpen, 'days') < 1) this.puedeModificar = true
      this.date = date.date
      this.indexSelected = this.promotorSelect.planificacion.findIndex(data => data.start === date.date)
      this.clientes = []
      if (this.indexSelected > -1) {
        this.clientes = [...this.promotorSelect.planificacion[this.indexSelected].clientes]
        for (const cliente of this.clientes) {
          const index = this.clientesArray.findIndex(c => c.value._id === cliente._id)
          if (index > -1) {
            this.clientesArray.splice(index, 1)
          }
        }
      }
      this.dialog = true
    },

    addCliente () {
      if (!this.clienteSelect) return null
      this.clientes.push({ idCliente: this.clienteSelect })
      const index = this.clientesArray.findIndex(cliente => cliente.value._id === this.clienteSelect._id)
      this.clientesArray.splice(index, 1)
      this.clienteSelect = null
    },

    deleteCliente (cliente) {
      const index = this.clientes.findIndex(c => c.idCliente._id === cliente.idCliente._id)
      this.clientes.splice(index, 1)
      this.clientesArray.push({
        value: cliente,
        text: cliente.idCliente.nombre
      })
    },

    close () {
      this.dialog = false
      this.indexSelected = -1
      this.clienteSelect = ''
      this.clientes = []
      this.date = ''
      this.puedeModificar = false
      this.getClientes() // cambiar
    },

    save () {
      const data = {
        clientes: this.clientes,
        name: `clientes (${this.clientes.length})`,
        start: this.date,
        end: this.date
      }
      if (this.indexSelected > -1) {
        this.promotorSelect.planificacion[this.indexSelected].clientes = [...this.clientes]
        this.promotorSelect.planificacion[this.indexSelected].name = `clientes (${this.clientes.length})`
        Api.put('planificacion', this.promotorSelect.planificacion[this.indexSelected])
          .then(res => {
            this.$swal({
              icon: 'success',
              title: 'Modificacion exitosa',
              text: 'Todos los cambios han sido efectuados'
            })
            // this.promotorSelect.planificacion.push(data)
            this.close()
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      } else {
        Api.post(`planificacion/${this.promotorSelect._id}`, data)
          .then(res => {
            this.$swal({
              icon: 'success',
              title: 'Modificacion exitosa',
              text: 'Todos los cambios han sido efectuados'
            })
            this.promotorSelect.planificacion.push(data)
            this.close()
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => { this.$swal.showLoading() }
      })
    }
  }
}
</script>
